import React, { memo, useCallback, useEffect, useState } from 'react';
import {
  Button,
  Card,
  Image,
  InputNumber,
  Row,
  Tabs,
  Typography,
  Divider,
} from 'antd';
import { ParMarketingResponse } from '../../services/assetconfig';
import { CATALOG_IMG_URL } from '../../utils/config';
import { PlusOutlined } from '@ant-design/icons';
import { toCurrency } from 'utils/utils';
import GetLabel from 'DisplayFramework/components/GetLabel';
import AssetCatalogSingleItemDetailModal from 'components/AssetCatalogModal/AssetCatalogSingleItemDetailModal';
import AssetCatalogPackItemDetailModal from './AssetCatalogPackItemDetailModal';

type AssetCatalogPackItemProps = {
  item: ParMarketingResponse;
  notitle?:Boolean;
  width?:number;
  onSelect: (item: ParMarketingResponse, nbasset: number) => void;
};
const { TabPane } = Tabs;

const AssetCatalogPackItem = (props: AssetCatalogPackItemProps) => {
  const { item, notitle,width,onSelect } = props;

  const [detailsVisible, setDetailsVisible] = useState(false);

  const [activeKey, setActiveKey] = useState('1');

  const imageSrc = CATALOG_IMG_URL + item?.pictureurl;

  const closeDetails = useCallback(() => {
    setDetailsVisible(false);
  }, []);

  const openDetails = useCallback(() => {
    setDetailsVisible(true);
  }, []);
  const [nbasset, setnbasset] = useState(1);
  

  useEffect(() => {});

  return (
    <Row justify="center">
      <Card
        title={notitle===false?'':
          <div style={{ color: 'red' }}>
            {item?.ofrtype === 'ASSET' ? 'Single Asset' : 'Pack'}
          </div>
        }
        style={{ alignContent: 'center', width: width??350, padding: 0 }}
        className="AssetCatalogPackItem"
        bordered
        cover={
          <Image alt={item?.mclabel} src={imageSrc} width={width??270} height={200} />
        }
        actions={[
          <Typography.Link key={1} onClick={() => onSelect(item, nbasset)}>
            <Button icon={<PlusOutlined />} type="primary">
              <GetLabel label="add" />
            </Button>
          </Typography.Link>,
          <InputNumber
            key={2}
            size="large"
            value={nbasset}
            min={1}
            max={100}
            bordered={false}
            onChange={(nb) => setnbasset(nb!)}
          />,
        ]}
      >
        <Divider />
        <Typography.Link key={1} onClick={openDetails}>
          <Card.Meta
            title={`${item?.mclabel}`}
            description={`${toCurrency(item?.assetnetamount, item?.currcode)}`}
            style={{ textAlign: 'center', fontSize: 20 }}
          />
        </Typography.Link>
      </Card>
      {item?.ofrtype === 'ASSET' ? (
        <AssetCatalogSingleItemDetailModal
          currcode={item?.currcode}
          item={item?.assets[0]!}
          visible={detailsVisible}
          onCancel={closeDetails}
          onSelect={() => {}}
        />
      ) : (
        <AssetCatalogPackItemDetailModal
          currcode={item?.currcode}
          item={item?.assets!}
          visible={detailsVisible}
          onCancel={closeDetails}
          onSelect={() => {}}
          Marketingitem={item}
          cataloglabel={item?.assets.map((assetlabel) => assetlabel.assetlabel)}
        />
      )}
    </Row>
  );
};

export default memo(AssetCatalogPackItem);
